import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import {auth as enAuth} from "./languages/en/auth";
import {auth as ruAuth} from "./languages/ru/auth";

import {basic as enBasic} from "./languages/en/basic";
import {basic as ruBasic} from "./languages/ru/basic";

import {calendar as enCalendar} from "./languages/en/calendar";
import {calendar as ruCalendar} from "./languages/ru/calendar";

import {passport as enPassport} from "./languages/en/passport";
import {passport as ruPassport} from "./languages/ru/passport";

import {registrationPage as enRegistrationPage} from "./languages/en/registrationPage";
import {registrationPage as ruRegistrationPage} from "./languages/ru/registrationPage";

import {LanguageEnum} from "../enum/language";

const resources = {
    en: {
        translation : {
            auth: enAuth,
            basic: enBasic,
            calendar: enCalendar,
            passport: enPassport,
            registrationPage: enRegistrationPage,
        }

    },
    ru: {
        translation: {
            auth: ruAuth,
            basic: ruBasic,
            calendar: ruCalendar,
            passport: ruPassport,
            registrationPage: ruRegistrationPage,
        }
    },
} as const;

i18n.use(initReactI18next).init({
    lng: LanguageEnum.Ru,
    interpolation: {
        escapeValue: false, // not needed for react as it escapes by default
    },
    resources,
});

export default i18n;